export enum FileListTypeEnum {
    Response = "Response",
    Finding = "Finding",
    Measure = "Measure",
}